/* @flow */
import Collection from 'lib/Collection';
import PotentialChatMember from 'entities/PotentialChatMember';

class PotentialChatMembers extends Collection {
  initialize() {
    this.url = '/chats/members/search/';
    this.model = PotentialChatMember;
  }

  getAvailableMembers() {
    return new PotentialChatMembers(this.filter(member => !member.isUnavailable()));
  }

  parse(response: Object) {
    return response.potential_chat_members;
  }
}

export default PotentialChatMembers;



// WEBPACK FOOTER //
// ./src/collections/PotentialChatMembers.js